<template>
  <div id="home">


    <div id="menu-mobile">
      <a href="https://aluno.somos10.com.br" class="button-body">
        <div class="icon">
          <img src="@/assets/icon_aluno.svg" alt="" />
        </div>
        <div class="label">Alunos</div>
      </a>

      <a href="https://coord.somos10.com.br" class="button-body">
        <div class="icon">
          <img src="@/assets/icon_coord.svg" alt="" />
        </div>
        <div class="label">Coordenadores</div>
      </a>
    </div>

    <div id="menu-wide">
      <a class="icon-body" href="https://aluno.somos10.com.br">
        <div class="icon">
          <img src="@/assets/icon_aluno.svg" alt="" />
        </div>
        <div class="label">Alunos</div>
      </a>
      <a class="icon-body" href="https://coord.somos10.com.br">
        <div class="icon">
          <img src="@/assets/icon_coord.svg" alt="" />
        </div>
        <div class="label">Coordenadores</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style lang="scss" scoped>
#home {
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  align-content: stretch;
  justify-content: center;
  flex: 1 1 auto;
  background-color: white;

  #menu-mobile {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 32px;

    .button-body {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      align-content: center;
      justify-content: flex-start;
      flex: 0 0 auto;
      text-decoration: none;
      border: none;
      outline: none;
      text-decoration: none;
      border-radius: 6px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
      cursor: pointer;
      background-color: #e5366d;
      height: 72px;
      margin: 16px 0px;
      width: 100%;
      color: white;
      font-size: 18px;
      font-weight: 500;

      &:hover {
        background-color: #ff5b8f;
      }

      .icon {
        display: block;
        flex: 0 0 auto;
        width: 54px;
        height: 54px;
        margin: 0px 16px;
        opacity: 0.7;
      }
    }
  }

  #menu-wide {
    display: none;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
    flex: 0 0 auto;
    width: 100%;
    max-width: 860px;

    .icon-body {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      align-content: center;
      justify-content: center;
      flex: 0 0 auto;
      text-decoration: none;
      border: none;
      outline: none;
      text-decoration: none;
      cursor: pointer;

      .icon {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        align-content: center;
        justify-content: center;
        width: 230px;
        height: 230px;
        border-radius: 50%;
        transition: all 0.2s ease-in-out;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        background-color: #e5366d;
        margin: 5px;
        box-sizing: border-box;

        img {
          width: 180px;
          transition: inherit;
        }
      }

      .label {
        display: block;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        margin-top: 16px;
        color: #2c2c2c;
        transition: color 0.2s ease-in-out;
      }

      &:hover {
        .icon {
          box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3),
            0 15px 12px rgba(0, 0, 0, 0.22);
          background-color: #ff5b8f;
          margin: 0px;
          width: 240px;
          height: 240px;

          img {
            width: 190px;
          }
        }

        .label {
          color: #607594;
        }
      }
    }
  }
}

@media only screen and (min-width: 540px) {
  #home {
    #menu-mobile {
      display: none;
    }

    #menu-wide {
      display: flex;
    }
  }
}

@media only screen and (min-width: 380px) {
  #home {
    #menu-mobile {
      .button-body {
        font-size: 26px;
      }
    }
  }
}
</style>
